import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartSimple, faCircleNotch, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';

function SubscribeCard({ subscribe_id, name, price, features, duration, roi }) {
    const { user } = useUser();
    const [rate, setRate] = useState(1);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [disable, setDisable] = useState(true);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [subscribe_name, setSubscribe_name] = useState(name);
    const [subscribeAmount, setSubscribeAmount] = useState(price);
    const [sduration, setSduration] = useState(duration);
    const [spercentage, setSpercentage] = useState(roi);
    const [sfeatures, setSfeatures] = useState(features);
    useEffect(() => {
      if(subscribe_name && sduration && subscribeAmount && spercentage && sfeatures){
        setDisable(false);
      }else{
        setDisable(true);
      }
    }, [subscribe_name, sduration, subscribeAmount, spercentage, sfeatures]);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    const [loading, setLoading] = useState(false);
    const ValidatePlan = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/subscription.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ btn_subscribe: true, subscribe_name: name, amount: price })
        })
        .then(response => response.json())
        .then(data => {
          if (data.status === "success") {
            toast.success(data.result);
            setTimeout(() => {
                window.location.href = "dashboard";
              }, 2000);
          }else{
            toast.error(data.message);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error(err)
          setLoading(false);
        })
    }

    const EditSubscription = () =>{
      setLoading1(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/subscription.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_editsubscribe: true, subscribe_id : subscribe_id, subscribe_name : subscribe_name, duration : sduration, amount : subscribeAmount, percentage : spercentage, features : sfeatures})
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          toast.success(data.result);
          setTimeout(() => {
            window.location.href = "subscribe";
          }, 2000);
        }else{
          toast.error(data.message);
        }
        setLoading1(false);
      })
      .catch(err => {
        console.error(err)
        setLoading1(false);
      })
    }
    const DeleteSubscription = () =>{
      setLoading2(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/subscription.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_deletesubscribe: true, subscribe_id : subscribe_id})
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          toast.success(data.result);
          setTimeout(() => {
            window.location.href = "subscribe";
          }, 2000);
        }else{
          toast.error(data.message);
        }
        setLoading2(false);
      })
      .catch(err => {
        console.error(err)
        setLoading2(false);
      })
    }

    return (
      <div className="mb-4 rounded-0 p-0 pb-4 position-relative" style={{background:'linear-gradient(179deg, #181d25, #0B0D10)'}}>
        {user?.user_type === "adminface" && (
          <p className="text-prime fw-semibold position-absolute" onClick={() => setIsOpen(true)} style={{cursor: 'pointer', fontSize:'14px',top:'20px',right:'20px'}}>Edit</p>
        )}
        <div className="p-3 d-flex justify-content-center mb-4" style={{backgroundColor:'#0B0D10'}}>
          <p className="mb-0 text-center d-inline-block px-4 py-1" style={{backgroundColor:'#010202'}}>{name} PLAN</p>
        </div>
        <p className="text-center text-secondary mb-0 text-uppercase" style={{fontSize:'14px'}}>Price</p>
        <div className="d-flex align-items-end justify-content-center mb-3">
          <p className="mb-0" style={{fontSize:'50px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate, 0)}</p>
          <p className="mb-0 text-secondary mb-2" style={{fontSize:'30px'}}>/{duration}d</p>
        </div>
        <div className="px-3">
          <div className="d-flex align-items-end">
            <p className="mb-0" style={{fontSize:'40px'}}>{formatCurrency(roi)}</p>
            <p className="mb-0 text-secondary mb-2 ms-1" style={{fontSize:'20px'}}>%</p>
            <FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} className="text-prime mb-3 ms-2" />
          </div>
          <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Estimated Subscription Yield</p>
          <div className={`myBtn w-100 rounded-0 text-center my-3`} style={{paddingTop: '15px',paddingBottom: '15px'}} onClick={ValidatePlan}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Subscribe'}</div>
          <div className="text-center">
              {features
              ?.split("\n")
              .filter(f => f.trim() !== "")
              .map((feature, index) => (
                  <p key={index} className="mb-2 fw-semibold text-white" style={{fontSize: '14px', textDecoration: 'underline dotted', textUnderlineOffset: '3px'}}>{feature}</p>
              ))}
          </div>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
          <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>
              Edit subscription plan</p>
              <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
          </div>
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Plan Name:</label>
          <div className="form-control py-2">
              <input 
                type="text"
                placeholder="Lite"
                className="inputNone"
                value={subscribe_name}
                onChange={(e) => setSubscribe_name(e.target.value)}
              />
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
              <input 
                type="number"
                placeholder="1000"
                className="inputNone"
                value={subscribeAmount}
                onChange={(e) => setSubscribeAmount(e.target.value)}
              />
              <div
                className="fw-bold text-white d-flex align-items-center"
                style={{
                  backgroundColor: 'rgb(30, 33, 36)',
                  borderRadius: '4px',
                  padding: '6px',
                  fontSize: '14px',
                  cursor: 'pointer' 
                }}
              >
                USD
              </div>
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Duration:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
              <input 
                type="number"
                placeholder="2"
                className="inputNone"
                value={sduration}
                onChange={(e) => setSduration(e.target.value)}
              />
              <div
                className="fw-bold text-white d-flex align-items-center"
                style={{
                  backgroundColor: 'rgb(30, 33, 36)',
                  borderRadius: '4px',
                  padding: '6px',
                  fontSize: '14px',
                  cursor: 'pointer' 
                }}
              >
                DAYS
              </div>
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>ROI:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
              <input 
                type="number"
                placeholder="2"
                className="inputNone"
                value={spercentage}
                onChange={(e) => setSpercentage(e.target.value)}
              />
              <div
                className="fw-bold text-white d-flex align-items-center"
                style={{
                  backgroundColor: 'rgb(30, 33, 36)',
                  borderRadius: '4px',
                  padding: '6px',
                  fontSize: '14px',
                  cursor: 'pointer' 
                }}
              >
                %
              </div>
          </div>
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Features:</label>
          <textarea 
            className="inputNone form-control "
            value={sfeatures}
            onChange={(e) => setSfeatures(e.target.value)}
          />
          <div className="d-flex align-items- justify-content-between" style={{gap: '10px'}}>
            <div className={`myBtn w-100 text-center mt-3 bg-danger`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={DeleteSubscription}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Delete'}</div>
            <div className={`myBtn w-100 text-center mt-3 bg-prime ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? EditSubscription : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
          </div>
        </Modal>
      </div>
    )
  }
  
  export default SubscribeCard